import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Student } from '../modal/student';

interface BulkDeleteStudentParams {
  studentIds: Array<string>;
}

export const bulkDeleteStudentAPI = async (params: BulkDeleteStudentParams) => {
  const response = await baseAPI.delete<Array<Student>>('/students/batch/all', {
    data: params.studentIds,
  });
  return response.data;
};

export const useBulkDeleteStudent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: BulkDeleteStudentParams) =>
      bulkDeleteStudentAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS],
      });
    },
  });
};
